// const {forEach} = require("../../../../dist/app");
const Basket = {
    name: 'basket',
    globalName: 'Basket',
    el: '#basket',
    data: function() {
        return {
            debug: true,
        };
    },
    mounted: function() {},
    methods: {
        test: function() {
            console.log('success!');
        },
        add: function (_this, id, quantity) {
            if (this.debug) {
                console.log('Добвление товара в корзину ('+id+')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'action': 'addToBasket',
                    'id': id,
                    'count': quantity,
                },
                type: 'post',
                dataType: 'json',
                success: function (response) {
                    _this.removeClass('buy-product');
                    _this.removeClass('btn-std');
                    _this.addClass('btn-black');
                    _this.attr("text", response.messages.inBasket);
                    _this.attr("hover-text", response.messages.delFromBasket);
                    _this.attr("del", '');
                    _this.attr("add", 'true');
                    // $('.mini-basket .count').text(response.items.length);
                    console.log(response);
                    // $('.mini-basket .basket-icon').addClass('_active-basket');
                    const basketIconNode = document.querySelector('.basket-icon');
                    const basketCounterNode = document.querySelector('.mini-basket .count');

                    if (basketCounterNode) {
                        let count = 0;
                            if (response.items && response.items.length) {
                                Object.values(response.items).forEach(el => {
                                    count += Number(el.count);
                                });
                                basketIconNode.classList.add('_active-basket');
                                basketCounterNode.classList.add('count-active');
                            } else {
                                count = 0;
                                basketCounterNode.classList.remove('count-active');
                            }

                        basketCounterNode.textContent = count;
                    }
                }
            });
        },
        changeQuantity: function (id, quantity) {
            if (this.debug) {
                console.log('Количестово обновлено ('+id+')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'count': quantity,
                    'action': 'changeQuantityBasket',
                },
                type: 'post',
                dataType: 'json',
                success: function(response){
                    $('.mini-basket .count').text(response.count);
                   let arr = response.items;
                   let result = $('.basket-table tbody tr td.total-price');
                    arr.forEach(function(item, i, arr) {
                        result[i].innerHTML = item.price.printTotalPrice;
                    });
                    $(".total-order .total-price")[0].innerHTML = response.price.printPrice;
                }
            });
        },
        del: function (_this, id) {
            if (this.debug) {
                console.log('Удаления товара из корзины (' + id + ')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'action': 'delFromBasket',
                },
                type: 'post',
                dataType: 'json',
                success: function (response) {
                    _this.removeClass('btn-black');
                    _this.addClass('buy-product');
                    _this.addClass('btn-std');
                    _this.attr("text", response.messages.buyProduct);
                    _this.attr('data-quant', '1');
                    _this.attr("hover-text", response.messages.delFromBasket);
                    _this.attr("del", 'true');
                    _this.attr("add", '');
                    var parent = _this.closest('.bot-ctrl-stripe');
                    var child = parent[0].querySelector('.js-quantity');
                    child.value = 1;
                    $('.buy-product').attr('data-quant', 1);
                    // $('.mini-basket .basket-icon').addClass('_active-basket');
                    const basketIconNode = document.querySelector('.basket-icon');
                    const basketCounterNode = document.querySelector('.mini-basket .count');

                    if (basketCounterNode) {
                        let count = 0;
                        if (response.items && response.items.length) {
                            Object.values(response.items).forEach(el => {
                                count += Number(el.count);
                            });
                        } else {
                            count = 0;
                            basketIconNode.classList.remove('_active-basket');
                            basketCounterNode.classList.remove('count-active');
                        }

                        basketCounterNode.textContent = count;
                    }
                }
            });
        },
        delItem: function (_this, id) {
            if (this.debug) {
                console.log('Удаления товара из корзины (' + id + ')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'action': 'delFromBasket',
                },
                type: 'post',
                dataType: 'json',
                success: function (response) {
                    _this.removeClass('btn-black');
                    _this.addClass('buy-product');
                    _this.addClass('btn-std');
                    _this.attr("text", response.messages.buyProduct);
                    _this.attr("hover-text", response.messages.delFromBasket);
                    var parent = _this.closest('.prod-right-cont');
                    var child = parent[0].querySelector('.count-form-group .js-quantity');
                    child.value = 1;
                    // $('.mini-basket .basket-icon').addClass('_active-basket');
                    const basketIconNode = document.querySelector('.basket-icon');
                    const basketCounterNode = document.querySelector('.mini-basket .count');

                    if (basketCounterNode) {
                        let count = 0;
                        if (response.items && response.items.length) {
                            Object.values(response.items).forEach(el => {
                                count += Number(el.count);
                            });
                        } else {
                            count = 0;
                            basketIconNode.classList.remove('_active-basket');
                            basketCounterNode.classList.remove('count-active');
                        }

                        basketCounterNode.textContent = count;
                    }
                }
            });
        },
        delInCompare: function (_this, id) {
            if (this.debug) {
                console.log('Удаления товара из корзины (' + id + ')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'action': 'delFromBasket',
                },
                type: 'post',
                dataType: 'json',
                success: function (response) {
                    _this.removeClass('btn-black');
                    _this.addClass('buy-product');
                    _this.addClass('btn-std');
                    _this.attr("text", response.messages.buyProduct);
                    _this.attr("hover-text", response.messages.delFromBasket);
                    _this.attr("del", 'true');
                    _this.attr("add", '');
                    // $('.mini-basket .basket-icon').addClass('_active-basket');
                    const basketIconNode = document.querySelector('.basket-icon');
                    const basketCounterNode = document.querySelector('.mini-basket .count');

                    if (basketCounterNode) {
                        let count = 0;
                        if (response.items && response.items.length) {
                            Object.values(response.items).forEach(el => {
                                count += Number(el.count);
                            });
                        } else {
                            count = 0;
                            basketIconNode.classList.remove('_active-basket');
                        }

                        basketCounterNode.textContent = count;
                    }
                }
            });
        },
    },
    // components: App.components
};
module.exports = Basket;
